import Axios from 'axios';
import Store from '@/vuex/store';

let endpoint_config = process.env.VUE_APP_ENDPOINT + process.env.VUE_APP_CONFIG_API,
  api,
  endpoints = {
    config: endpoint_config,
  };

function set_axios_parameters(parameters) {
  return JSON.stringify({
    ...parameters,
    token: Store.state.token,
  });
}

// api_promise_handler gestisce una copia (passata per valore) della promise di axios per permettere di gestire l'errore a questo livello ed anche a livello di componente
// la promise originale, SENZA error handler, viene ritornata al componente: in questo modo il componente può fare la sua gestione dell'errore e della response
// la gestione di error/response delle due promises (una gestita a questo livello, una ritornata al componente) sono parallele, completamente indipendenti e opzionali: possono essere implementate entrambe, una sola delle due, nessuna
function api_promise_handler(
  promise,
  params = {
    caller: 'api.js',
    success: (r) => {
      r;
    },
    error: (e) => {
      e;
    },
  }
) {
  promise
    .then((response) => {
      params.success(response);
    })
    .catch((error) => {
      window.console.log(params.caller + ' error');
      window.console.log(error);
      params.error(error);
    });
}

// notifications
function send_notification(error) {
  let callback = function () {
    return window.console.log('Nessuna azione prevista');
  };

  let data = error.response && error.response.data ? error.response.data : '';
  if (data == '' && error.data) data = error.data;

  if (data == '') {
    // errore non gestito lato server (es. PHP FATAL ERROR)
    data = {};
    data.routerPush = 'homepage';
  }

  if (error.response && error.response.status) data.status = error.response.status;
  data.callback = callback;
  window.eventBus.$emit('got_modal_notification', data);
  return error.response;
}

export function test_notification(queryParameters) {
  //test http errors
  let promise = Axios.post(endpoints.testNotifications, {
    httpStatusCode: queryParameters.httpCode,
  });
  // comportamenti da gestire a livello api.js (es. send_notification)
  promise.then(
    () => {
      window.console.log('[api.js] - success');
    },
    (error) => {
      window.console.log('[api.js] - error');
      send_notification(error);
    }
  );
  // altri comportamenti da gestire a livello di componente, con callback dedicati ( -> un'altra .then() )
  return promise;
}

export function get_config(token) {
  api = Axios.create({
    headers: {
      //'Authorization': 'Bearer ' + token,
      post: {},
      get: {},
    },
  });
  let params = { token: token };
  return api.post(endpoints.config, params).then(
    (response) => {
      endpoints = response.data.endpoints;
      endpoints.config = endpoint_config;
      return response.data;
    },
    (error) => {
      window.console.log(error);
    }
  );
}

export function get_locations(q) {
  //let params = set_axios_parameters(q)
  let params = JSON.stringify({
    ...q,
    lang: 'IT', // alpha2 country code
  });
  return new Promise((resolve) => {
    if (q.q.length < 3) {
      return resolve([]);
    }
    api.post(endpoints.locations, params).then(
      (response) => {
        let suggestions =
          response.data && response.data.suggestions ? response.data.suggestions : [];

        suggestions = suggestions.filter(function (s) {
          return s.iata_code;
        }); // filtro suggestions senza iata_code

        if (suggestions.length == 0)
          suggestions = [
            {
              type: 'noresults',
              iata_code: '',
              name_full: 'nessun risultato',
            },
          ];

        resolve(suggestions);
      },
      () => {
        //window.console.log(error)
        //return send_notification(error)

        // ho dovuto disattivare la modal notification per l'autocomplete
        // altrimenti in caso di "errori" va in loop
        // (chiudendo la modal l'autocomplete riprende il focus e riprova la ricerca, scatenando altro errore)

        resolve([
          {
            type: 'noresults',
            iata_code: '',
            name_full: 'si è verificato un problema con la ricerca',
          },
        ]);
      }
    );
  });
}

export function get_flight_offers(request) {
  request.getFlightOffersBody.sources = ['GDS', 'PYTON', 'LTC', 'EAC'];
  let params = set_axios_parameters(request);

  /* ricerca con tasse:
        sources: tutte
        amsterdam ams - londra lon A/R 15 settembre 22 settembre
    */

  /* ricerca con bagagli:
        sources: 'PYTON'
        tutti gli aeroporti di milano - tutti gli aeroporti londra 15 agosto sola andata
    */

  let promise = api.post(endpoints.flightOffers, params);

  promise.then(
    () => {},
    (error) => {
      window.console.log('get_flight_offers error');
      window.console.log(error);
      return send_notification(error);
    }
  );

  return promise;
}

export function get_flight_offers_price(request) {
  // per i bagagli aggiungi: /?include=bags
  let params = set_axios_parameters(request);

  let promise = api.post(endpoints.flightOffersPrice, params);

  promise.then(
    (response) => {
      return response.data;
    },
    (error) => {
      window.console.log('get_flight_offers_price error');
      window.console.log(error);
      return send_notification(error);
    }
  );

  return promise;
}

export function get_flight_offers_upsell(request) {
  let params = set_axios_parameters(request);
  let promise = api.post(endpoints.flightOffersUpsell, params);

  promise.then(
    (response) => {
      return response.data;
    },
    (error) => {
      window.console.log('get_flight_offers_upsell error');
      window.console.log(error);
      return send_notification(error);
    }
  );

  return promise;
}

/**
 * Fetches the seat configuration for the flights segments
 * @returns {Promise<any>}
 */
export function getSeatMap(request) {
  let params = set_axios_parameters(request);
  let promise = api.post(endpoints.seatmaps, params);

  promise.then(
    (response) => {
      return response.data;
    },
    (error) => {
      window.console.log('get_seat_map error');
      window.console.log(error);
      return send_notification(error);
    }
  );

  return promise;
}

export function checkout() {
  let params = set_axios_parameters({
      bookingData: Store.state.booking_data,
      ...Store.state.guests,
    }),
    promise = api.post(endpoints.checkout, params);

  promise.then(
    (success) => {
      window.console.log('[api.js] - checkout success');

      if (success.status == 202) return send_notification(success);
    },
    (error) => {
      window.console.log('checkout error');
      window.console.log(error);
      return send_notification(error);
    }
  );

  return promise;
}

export function confirm(request) {
  let params = set_axios_parameters(request);

  return api.post(endpoints.confirm, params).then(
    (response) => {
      return response.data;
    },
    (error) => {
      window.console.log('confirm error');
      window.console.log(error);
      return send_notification(error);
    }
  );
}

export function otp(request) {
  let params = set_axios_parameters(request);

  let promise = api.post(endpoints.otp, params);

  return promise;
}

export function dc_login(request) {
  let params = set_axios_parameters(request);

  let promise = api.post(endpoints.dcLogin, params);

  promise.then(
    () => {},
    (error) => {
      window.console.log('dc_login error');
      window.console.log(error);
      send_notification(error);
    }
  );

  return promise;
}

export function dc_check(request) {
  let params = set_axios_parameters(request);

  return api.post(endpoints.dcCheck, params).then(
    (response) => {
      response;
      return response;
    },
    (error) => {
      window.console.log('dc_check error');
      window.console.log(error);
      return send_notification(error);
    }
  );
}

export function get_beneficiaries(request) {
  let params = set_axios_parameters(request),
    promise = api.post(endpoints.beneficiaries, params);

  promise.then(
    () => {
      window.console.log('[api.js] - beneficiaries success');
    },
    (error) => {
      window.console.log('checkout error');
      window.console.log(error);
      return send_notification(error);
    }
  );

  return promise;
}

export function stripe_create_intent_client_secret(request) {
  let params = set_axios_parameters(request),
    promise = api.post(endpoints.stripeCreateIntentClientSecret, params);
  api_promise_handler(promise, {
    caller: 'stripe_create_intent_client_secret',
    success: (response) => {
      response;
      // nessuna azione prevista
    },
    error: (error) => {
      // trigger modal di errore
      send_notification(error);
    },
  });

  return promise;
}

export function logout() {
  // la chiamata a logout invalida la sessione (token) lato server
  // e farà ricaricare l'applicazione tramite modal notification redirectTo /

  let params = set_axios_parameters({}),
    promise = api.post(endpoints.logout, params);

  promise.then(
    () => {
      window.console.log('[api.js] - logout success');
    },
    (error) => {
      return send_notification(error);
    }
  );

  return promise;
}

export function jp_sso(data) {
  // la chiamata a logout invalida la sessione (token) lato server
  // e farà ricaricare l'applicazione tramite modal notification redirectTo /

  let params = set_axios_parameters(data),
    promise = api.post(endpoints.jpSso, params);

  promise.then(
    () => {
      window.console.log('[api.js] - logout success');
    },
    (error) => {
      return send_notification(error);
    }
  );

  return promise;
}

export function jp_checkout(data) {
  // la chiamata a logout invalida la sessione (token) lato server
  // e farà ricaricare l'applicazione tramite modal notification redirectTo /

  let params = set_axios_parameters(data);

  let promise = api.post(endpoints.jpCheckout, params);

  promise.then(
    () => {},
    (error) => {
      return send_notification(error);
    }
  );

  return promise;
}

export function forms_submitter(data) {
  let params = set_axios_parameters(data);

  let promise = api.post(endpoints.formsSubmitter, params);

  promise.then(
    () => {},
    (error) => {
      return send_notification(error);
    }
  );

  return promise;
}

// payments link get
export function pl_get(request) {
  let params = set_axios_parameters(request);

  let promise = api.post(endpoints.paymentsLink.get, params);

  promise.then(
    () => {},
    (error) => {
      window.console.log('payments_link get error');
      window.console.log(error);
      send_notification(error);
    }
  );

  return promise;
}

// payments link buy
export function pl_buy(request) {
  let params = set_axios_parameters(request);

  let promise = api.post(endpoints.paymentsLink.buy, params);

  promise.then(
    () => {},
    (error) => {
      window.console.log('payments_link buy error');
      window.console.log(error);
      send_notification(error);
    }
  );

  return promise;
}
